export enum DataType {
    //default null
    NULL_VALUE="",
    //original values 
    STRING = "STRING",
    DOUBLE = "DOUBLE",
    INTEGER = "INTEGER",
    BOOLEAN = "BOOLEAN"
}